export const validateBonusTimeMessage = (message: string): boolean => {
  return /bonus\s+time/i.test(message);
};
